(function () {
  /** @param {'cart' | 'account'} tab */
  function openSparkDrawer(tab = 'account') {
    const allowed = new Set(['cart', 'account']);
    const view = allowed.has(tab) ? tab : 'cart';

    const existing = document.querySelector('spark-drawer');

    if (!existing) {
      const el = document.createElement('spark-drawer');
      el.setAttribute('initial-tab', view);
      document.body.appendChild(el);
      return;
    }

    window.dispatchEvent(
      new CustomEvent('view-update', {
        bubbles: true,
        composed: true,
        detail: { view },
      }),
    );
  }

  Theme.openSparkDrawer = openSparkDrawer;
})();
